import styled from 'styled-components'

import DeleteButton from 'components/molecules/DeleteButton'

const Delete = styled(DeleteButton)`
  z-index: 1;
`
export default Delete
